/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import axios from "axios";
import store from "@/store";
import { pathConstants } from "../../shared/pathConstants";
import { helpers } from "@/shared/helper";
import Vue from "vue";

export const documentService = {
  fetchDocumets,
  editDocumentType,
  downloadDocuments,
  downloadDocument,
  downloadCommonDocument,
  viewCommonDocument,
  editDocumentOperations,
  deleteDocuments,
  saveDocuments,
  replaceDocument,
  versionsDocument,
  deleteDraftDocuments
};

function fetchDocumets(id, customFilter, search, myPager) {
  return axios
    .post(`${pathConstants.API}/documents/${id}`, {
      myPager,
      customFilter,
      search
    })
    .then(
      result => {
        return result.data;
      },
      err => {
        Vue.$log.error("fetchDocumets", err);
      }
    );
}

function editDocumentType(documents) {
  return axios
    .post(pathConstants.API + "/documents/edit-document-type", documents)
    .then(
      result => {
        return result.data;
      },
      err => {
        Vue.$log.error("editDocumentType", err);
      }
    );
}

function deleteDocuments(documentsIds) {
  return axios
    .post(pathConstants.API + "/documents/delete-documents", documentsIds)
    .then(
      result => {
        return result.data;
      },
      err => {
        Vue.$log.error("deleteDocuments", err);
      }
    );
}

function downloadDocuments(selectedDocumentsIds) {
  store.commit("loader/showDownloadDocumentLoader");
  axios({
    url: pathConstants.API + "/documents/download",
    data: selectedDocumentsIds,
    method: "POST",
    responseType: "blob",
    showLoader: false
  })
    .then(response => {
      helpers.downloadFile(response);
    })
    .finally(() => store.commit("loader/hideDownloadDocumentLoader"));
}

function downloadDocument(id) {
  store.commit("loader/showDownloadDocumentLoader");
  return axios({
    url: pathConstants.API + `/documents/download/${id}`,
    method: "POST",
    responseType: "blob",
    showLoader: false
  })
    .then(response => {
      helpers.downloadFile(response);
    })
    .finally(() => store.commit("loader/hideDownloadDocumentLoader"));
}

function downloadCommonDocument(id) {
  store.commit("loader/showDownloadDocumentLoader");
  return axios({
    url: pathConstants.API + `/commonDocuments/download/${id}`,
    method: "GET",
    responseType: "blob",
    showLoader: false
  })
    .then(response => {
      helpers.downloadFile(response);
    })
    .finally(() => store.commit("loader/hideDownloadDocumentLoader"));
}

function replaceDocument(documentReplace) {
  return axios
    .put(
      pathConstants.API + "/commonDocuments/opportunity/replace",
      documentReplace
    )
    .then(
      () => {},
      err => {
        Vue.$log.error("replaceDocument", err);
      }
    );
}

function versionsDocument(docId) {
  return axios({
    url: pathConstants.API + `/commonDocuments/document-versions/${docId}`,
    method: "GET",
    showLoader: false
  }).then(
    response => {
      return response.data;
    },
    err => {
      Vue.$log.error("versionsDocument", err);
    }
  );
}

async function viewCommonDocument(id) {
  const response = await axios({
    url: pathConstants.API + `/commonDocuments/download/${id}`,
    method: "GET",
    responseType: "blob",
    showLoader: false
  });

  helpers.viewFile(response);
}

function editDocumentOperations(documentsOperations) {
  axios
    .post(
      pathConstants.API + "/commonDocuments/edit-document-operations",
      documentsOperations
    )
    .then(
      () => {},
      err => {
        Vue.$log.error("editDocumentOperations", err);
      }
    );
}
function saveDocuments(documentsToUpload) {
  return axios
    .post(`${pathConstants.API}/documents`, documentsToUpload, {
      showLoader: false
    })
    .then(
      () => {},
      err => {
        Vue.$log.error("saveDocuments", err);
      }
    );
}

function deleteDraftDocuments(documentsName, showLoader) {
  return axios
    .post(pathConstants.API + "/documents/clean-draft", documentsName, {
      showLoader: showLoader
    })
    .then(
      result => {
        return result.data;
      },
      err => {
        Vue.$log.error("deleteDraftDocuments", err);
      }
    );
}
